export default class ActivityEvent {
    //--------------------------------------------------------------------------
    //
    //  Properties
    //
    //--------------------------------------------------------------------------

    //----------------------------------
    //  Public:
    //----------------------------------

    public static COMPLETE: string = "complete";

    public static REPLAY_AUDIO: string = "replayAudio";
    public static PLAY_INTRO_AUDIO: string = "playIntroAudio";
    public static PLAY_INTRO_AUDIO_COMPLETE: string = "playIntroAudioComplete";
    public static PROCEED_TO_BONUS_ROUND: string = "proceedToBonusRound";
    public static DISABLE_REPLAY_AUDIO_BTN: string = "disableReplayAudioBtn";
    public static ENABLE_REPLAY_AUDIO_BTN: string = "enableReplayAudioBtn";

    // Assessment Events
    public static ANSWER_CLICK: string = "answerClick";
    public static ASSESSMENT_COMPLETE: string = "Asmt1Event:assessmentComplete";
    public static DROPLET_CLICK: string = "dropletClick";
    public static QUIZ_ITEM_COMPLETE: string = "Asmt1Event:quizItemComplete";
    public static ASSESSMENT_LOAD_ASSETS_COMPLETE: string = "Asmt1Event:loadAssetsComplete";
    public static MULTI_SKILL_LOAD_ASSETS_COMPLETE: string = "Asmt1Event:loadAssetsCompleteMultiSkill";

    // Activity 1 Events
    public static ANSWER_BTN_FADE_OUT_COMPLETE: string = "A1Event:answerBtnFadeOutComplete";
    public static ANSWER_BTN_FADE_IN_COMPLETE: string = "A1Event:answerBtnFadeInComplete";
    public static ACTIVITY1_COMPLETE: string = "A1Event:activity1Complete";
    public static LOOP_FADE_OUT_COMPLETE: string = "A1Event:loopFadeOutComplete";
    public static ACTIVITY1_LOAD_ASSETS_COMPLETE: string = "A1Event:loadAssetsComplete";
    public static NEXT: string = "A1Event:next";
    public static PLAY_SOUND_FX: string = "A1Event:playSoundFx";
    public static STOP_SOUND_FX: string = "A1Event:stopSoundFx";
    public static TRY_AGAIN: string = "A1Event:tryAgain";

    // Activity 2 Events
    public static WRONG_ANSWER: string = "Activity2:wrongAnswer";
    public static ACTIVITY2_LOAD_ASSETS_COMPLETE: string = "A2Event:loadAssetsComplete";
    public static ADVANCE_NEXT_ROOM: string = "A2Event:advanceNextRoom";

    // Activity 3 Events
    public static ACTIVITY3_LOAD_ASSETS_COMPLETE: string = "A3Event:loadAssetsComplete";
}
